import { render } from "./BaseRadioOther.vue?vue&type=template&id=6e3927a0"
import script from "./BaseRadioOther.vue?vue&type=script&lang=js"
export * from "./BaseRadioOther.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__